import React from "react";
import { Link } from "react-router-dom";
import NotFoundSvg from "../assets/images/undraw_page-not-found_6wni.svg";
import { PageSectionHeader } from "../components/subcomponents/PageSectionHeader";

export const NotFound: React.FC = () => {
    return (
        <div className="page-content has-global-padding is-layout-constrained page-status">
            <img
                src={NotFoundSvg}
                alt=""
                className="page-status__illustration"
            />
            <PageSectionHeader
                eyebrow="Erreur 404"
                title="Page non trouvée"
                lead="La page que vous recherchez n'existe pas ou a été déplacée."
                align="center"
            />
            <p className="page-status__actions">
                <Link to="/" className="page-status__link">Retour à l&apos;accueil</Link>
            </p>
        </div>
    );
};
